import React from 'react';

import s from './styles.module.scss';
import { fieldTypeComponents } from './field-type-components';

import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type {
  TFormItem,
  FieldValueMap,
  TFieldProps,
  IMaCriticalData,
} from '../types';

function renderField<K extends keyof FieldValueMap>(
  type: K,
  props: TFieldProps<K>,
) {
  return fieldTypeComponents[type](props);
}

interface FormItemProps {
  item: TFormItem;
  formik: FormikProps<IMaCriticalData>;
}

const MaCriticalFormItem: FC<FormItemProps> = ({ item, formik }) => {
  const { values, setFieldValue } = formik;

  if (item.type === 'info') {
    return <div className={s.wrapper}>{item.html}</div>;
  }

  type TName = keyof IMaCriticalData;

  const value = values?.[item.name as TName] as any;
  const isTitleValid = React.isValidElement(item.title);

  const onChange = (val: FieldValueMap[typeof item.type]) => {
    const key = `${item.name}`;
    setFieldValue(key, val);
  };

  return (
    <>
      <div className={s.wrapper}>
        {isTitleValid && (
          <div className={s['critical-title-wrapper']}>
            {item.title} {item.required && <span>*</span>}
          </div>
        )}
        {item.description && (
          <div className={s['critical-description-wrapper']}>
            <p>{item.description}</p>
          </div>
        )}
        {renderField(item.type, {
          item,
          value,
          onChange,
          formik,
          readingStatus: undefined,
          readingType: undefined,
          form: 'critical',
        })}
      </div>
      {item?.items?.map((i) => (
        <MaCriticalFormItem item={i} key={i.key} formik={formik} />
      ))}
    </>
  );
};
export default MaCriticalFormItem;
